import ShareProperty from "./ShareProperty";
import SharedUser from "./SharedUser";
import { SHARE_PATHS } from "./shareUtils";

export { SHARE_PATHS };

// Share Property (app/screens/ShareProperty/*): /share-property, and
// /share-property/user opened with { share } from its Shared Users list.
export const SHARE_ROUTES = [
  { path: SHARE_PATHS.HOME, component: ShareProperty },
  { path: SHARE_PATHS.USER, component: SharedUser },
];
